import { Type } from "class-transformer";
import { DatevRechercheResult } from "./DatevRechercheResult";

export class DatevRechercheGroup {
    documentNumber = "";
    amount = 0;
    @Type(() => DatevRechercheResult)
    items: DatevRechercheResult[];
}
